import React, { useEffect, useRef, useState } from 'react'
import Skeleton from '@material-ui/lab/Skeleton'

//helpers
import Api from '../../../__helpers/api'

//components
import Student from './Student'

//dispatcher
import { useSelector } from 'react-redux'

//modals
import Question from '../../modals/Question'
import TransferStudent from '../modals/actions/TransferStudent'

let initialData

function Students() {
    const __state = useSelector(state => state)
    //
    const currentGroup = __state.instructorReducer.group?.current || ''
    const currentTopic = __state.instructorReducer.topic?.current || ''
    const sortStudentsByWrongAnswers = __state.instructorReducer.student?.sortByIds || []

    const [state, setState] = useState({
        students: [],
        loading: true,
        sorted: false,
    })

    //refs
    const questionModalRef = useRef(null)
    const transferStudentRef = useRef(null)

    useEffect(() => {
        getData()
    }, [currentGroup, currentTopic])

    const getData = () => {
        loading(true)

        if (currentGroup) {
            const url = `center/students/topic-stats?group_id=${currentGroup}&topic_id=${currentTopic}`

            Api.get(url)
                .then(res => {
                    setState(students => ({
                        ...students,
                        students: res.data,
                    }))
                })
                .then(() => {
                    loading(false)
                })
        } else {
            loading(false)
        }
    }

    const handleDelete = id => {
        questionModalRef.current.open({
            id
        })
    }

    const confirmDelete = data => {
        loading(true)
        Api.post('center/students/delete', {
            user_id: data.id
        })
            .finally(() => {
                getData()
            })
    }

    const loading = loading => {
        setState(prev => ({
            ...prev,
            loading
        }))
    }


    useEffect(() => {
        if (!state.sorted) {
            initialData = state.students
        }

        if (sortStudentsByWrongAnswers[0]) {
            const sortedStudents = state.students.sort(student => {
                // student.id == sortStudentsByWrongAnswers.map(id => id)
            })

            console.log(sortedStudents)
        }
    }, [sortStudentsByWrongAnswers])

    const handleTransfer = id => {
        transferStudentRef.current.open(id)
    }
    
    return (
        <div className="students">
            <Question
                ref={questionModalRef}
                mainMessage="Сигурни ли сте, че искате да продължите с изтриването?"
                secondaryMessage="Авто Обучение не носи отговорност за изтритите от Вас данни."
                handleConfirm={confirmDelete}
            />
            <TransferStudent 
                ref={transferStudentRef}
            />
            <h3>
                Моите курсисти
            </h3>
            <p>
                Списък с курсистите и техния прогрес в обучението
            </p>
            <div className="holder">
                <ul>
                    {state.loading ?
                        <>
                            <Skeleton className="answer-skeleton" style={{ height: '51px' }} />
                            <Skeleton className="answer-skeleton" style={{ height: '51px' }} />
                            <Skeleton className="answer-skeleton" style={{ height: '51px' }} />
                            <Skeleton className="answer-skeleton" style={{ height: '51px' }} />
                            <Skeleton className="answer-skeleton" style={{ height: '51px' }} />
                        </>
                        :
                        state.students[0] ?
                            state.students.map(student =>
                                <Student
                                    student={student}
                                    handleDelete={handleDelete}
                                    handleTransfer={handleTransfer}
                                />
                            ) :
                            <li className="no-data">
                                Няма курсисти в групата
                        </li>
                    }
                </ul>
            </div>
        </div>
    )
}

export default Students